// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip__XW2BWK"};